import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Radio extends Component {
  static propTypes = {
    name: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    radioId: PropTypes.string,
    value: PropTypes.string,
    wrapperClassName: PropTypes.string,
    radioClassName: PropTypes.string,
  }

  static defaultProps = {
    checked: false,
  }

  render() {
    const wrapperClass = classNames('radio__wrapper', this.props.wrapperClassName)

    return (
      <div className={wrapperClass} onClick={this.props.onChange}>
        <input
          id={this.props.radioId}
          type="radio"
          name={this.props.name}
          checked={this.props.checked}
          onChange={this.props.onChange}
          value={this.props.value}
          className={this.props.radioClassName}
        />
        <span className="radio-button" />
        {this.props.children}
      </div>
    )
  }
}

export default Radio
